import i18n from '@/lib/i18n';
import { localizePath } from '@/lib/locales';

function applyLocaleToAs(as) {
  if (typeof as !== 'string') {
    return as
  }

  const locale = i18n.language || 'en'

  if (locale === 'en') {
    return as
  }

  const [pathname, query] = as.split('?')
  const localizedPath = localizePath(pathname, locale)

  return query ? `${localizedPath}?${query}` : localizedPath
}

export default function generateLinkParams({ type, slug, parentSlug }) {
  const t = (key) => i18n.t(key, { ns: 'global' });
  let href = ''
  let as = ''
  let title = ''

  switch (type) {
    case 'index':
      href = '/'
      as = '/'
      break
    case 'direction':
    case 'subdirection':
      href = '/[typeSlug]'
      as = `/${slug}`
      title = t('menu.subdirectionTitle')
      break
    case 'service':
      href = '/[typeSlug]/[serviceSlug]'
      as = `/${parentSlug}/${slug}`
      title = t('menu.serviceTitle')
      break
    case 'services':
      href = '/services'
      as = '/services'
      title = t('menu.servicesTitle')
      break
    case 'text-page':
      if (slug === 'patient-and-family-bill-of-rights-and-responsibilities') {
        href = '/patient-and-family-bill-of-rights-and-responsibilities'
        as = '/patient-and-family-bill-of-rights-and-responsibilities'
        title = 'Patient & Family Bill of Rights and Responsibilities'
      } else {
        href = '/[typeSlug]'
        as = `/${slug}`
      }
      break
    case 'specialists':
      href = '/specialists'
      as = '/specialists'
      title = t('menu.specialistsTitle')
      break
    case 'specialist':
      href = '/specialists/[specialistSlug]'
      as = `/specialists/${slug}`
      title = t('menu.specialistTitle')
      break
    case 'promotions':
      href = '/promotions'
      as = '/promotions'
      title = t('menu.promotionsTitle')
      break
    case 'promotion':
    case 'promo':
      href = '/promotions/[promotionSlug]'
      as = `/promotions/${slug}`
      title = t('menu.promoTitle')
      break
    case 'contacts':
      href = '/contacts'
      as = '/contacts'
      title = t('menu.contactsTitle')
      break
    case 'wiki':
      href = '/wiki'
      as = '/wiki'
      title = t('menu.wikiTitle')
      break
    case 'wiki-article':
    case 'encyclopedia':
      href = '/wiki/[wikiArticleSlug]'
      as = `/wiki/${slug}`
      title = t('menu.encyclopediaTitle')
      break
    case 'blog':
      href = '/blog'
      as = '/blog'
      title = t('menu.blogTitle')
      break
    case 'article':
      href = '/blog/[articleSlug]'
      as = `/blog/${slug}`
      title = t('menu.articleTitle')
      break
    case 'reviews':
      href = '/reviews'
      as = '/reviews'
      title = t('menu.reviewsTitle')
      break
    case 'search':
      href = '/search'
      as = '/search'
      title = t('menu.searchTitle')
      break
    case 'legalRights':
      href = '/patient-rights-and-responsibilities'
      as = '/patient-rights-and-responsibilities'
      title = 'Patient Rights and Responsibilities'
      break  
    case 'legalFamilyBill':
      href = '/patient-and-family-bill-of-rights-and-responsibilities'
      as = '/patient-and-family-bill-of-rights-and-responsibilities'
      title = 'Patient & Family Bill of Rights and Responsibilities'
      break   
    case 'privacyPolicy':
      href = '/privacy-policy'
      as = '/privacy-policy'
      title = 'Privacy Policy'
      break         
    default:
      break
      return
  }

  return [href, applyLocaleToAs(as), title]
}
